<box>
  <app-header [title]="'ship_interface.create_new_monthly_rob_report' | transloco" [hasCloseButton]="true" (close)="onDiscard()"></app-header>
  <app-body>
    <container customClass="gap-[2px]">
      <div class="gap-2">
        <p class="font-semibold">{{ 'ship_interface.latest_monthly_rob_report_submitted' | transloco }}</p>
        <p class="text-2xl font-bold text-primary">{{ lastReportTitle }}</p>
      </div>
      <div class="flex items-center gap-[3px] font-semibold">
        <mat-icon [svgIcon]="'heroicons_outline:copy'" class="icon-copy-size mx-[2px]"></mat-icon>
        <p class="font-semibold text-slate-600">{{ 'ship_interface.copy_from_latest_report' | transloco }}</p>
        <toggle [hasPadding]="false" class="ml-2" [control]="form.get('flag_copy')"></toggle>
      </div>
    </container>
    <row>
      <textbox
        [control]="form.get('year')"
        class="w-full"
        [label]="'ship_interface.report_year' | transloco"
        [required]="true"
        [showIndicator]="true"
        [placeholder]="'ship_interface.year' | transloco">
      </textbox>
      <dropdown
        [control]="form.get('month')"
        class="w-full"
        [label]="'ship_interface.report_month' | transloco"
        [required]="true"
        [options]="months"
        selectType="value"
        displayName="name"
        [placeholder]="'ship_interface.select_month' | transloco">
      </dropdown>
    </row>
    <textbox
      [control]="form.get('remarks')"
      [hasPadding]="true"
      [label]="'ship_interface.remarks' | transloco"
      [placeholder]="'ship_interface.enter_remarks_if_any' | transloco">
    </textbox>
  </app-body>
  <app-footer
    [onSave]="null"
    [hasSaveButton]="['monthly_rob_ship_interface', ['create']] | permission"
    [hasDiscardButton]="true"
    (discard)="onDiscard()"
    (save)="onSave()">
  </app-footer>
</box>
